import React from "react";
import {
  Button,
  Col,
  FormControl,
  FormLabel,
  Row,
  Table,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  FabricStyleBean,
  FabricStyleSearchCriteria,
  ManualInventoryCustomerAllocationBean,
  ManualInventoryCustomerAllocationSearchCriteria,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestManualInventoryCustomerAllocationListRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DatePickerComponent,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { PopupFabricModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
class ManualInventoryAllocationDetails extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.customerCodeRef = React.createRef();
    this.fabricCodeRef = React.createRef();
    this.colorCodeRef = React.createRef();
    this.customerCodePopupRef = React.createRef();
    this.fabricCodePopupRef = React.createRef();
    this.colorCodePopupRef = React.createRef();
    this.state = {
      pageTitle: "Manual Inventory Allocation",
      isShowExitButton: true,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      error_list: [],
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      isInventoryDatasFound: false,
      inventoryDataList: [],
      criteria: new ManualInventoryCustomerAllocationSearchCriteria(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      fabricLookupHandler: null,
      colorLookupHandler: null,
      customerLookupHandler: null,
      colorList: [],
      fabricStyleData: new FabricStyleBean(),
      isShowColorLookup: false,
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricColorList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      isShowFabricStyleModule: false,
      isShowLookup: true,
      isShowPopupLookup: true,
      isDisableFields: false,
      isShowDisableFields: false,
      moduleForPopup: [],
      isShowFetchButton: true,
      isShowNewLinePopup: false,
      showClearButton: false,
      inventoryAllocationData: new ManualInventoryCustomerAllocationBean(),
      fabricPageListForPopupAutoCompleteList: new Array(),
      showAutoCompletePopupFabricList: true,
      fabricColourPageListForPopupAutoCompleteList: new Array(),
      showAutoCompletePopupFabricColorList: true,
      customerPageListForPopupAutoCompleteList: new Array(),
      showAutoCompletePopupCustomerList: true,
      isShowPopupAlert: false,
      isShowPopupColorLookup: false,
      is3PL: false,
      order: "asc",
      sortField: "",
      //isViewMode: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.initLookupHandlers();
    let criteria = this.state.criteria;
    criteria.status = "O";
    this.setState({ criteria: criteria });
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  fetch = (e) => {
    if (e.detail === 1) {
      this.hideAlertCallBack();
      this.loadPage(1);
    }
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    if (!isEmpty(criteria.customerCode)) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing...",
      });
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 50;
      pageInput.currentPage = pageNumber;
      let listRequest = new RestManualInventoryCustomerAllocationListRequest();
      listRequest.searchCriteria = criteria;
      listRequest.pageInput = pageInput;
      this.loadManualInventoryList(listRequest);
    } else {
      let errMsg = "Invalid Customer!";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadManualInventoryList = (listRequest) => {
    if (SecurityAccessManager.CustomerAllocationMaintenance_IsAccessible()) {
      InventoryService.getManualInventoryCustomerAllocationPageList(
        listRequest,
        this.loadManualInvenotryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadManualInvenotryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.customerAllocationPageList != null
    ) {
      let customerAllocations = new Array();
      if (
        !isEmptyArray(
          response.data.customerAllocationPageList.customerAllocations
        )
      ) {
        customerAllocations =
          response.data.customerAllocationPageList.customerAllocations;
      }
      this.setState({
        isInventoryDatasFound: true,
        inventoryDataList: customerAllocations,
        isShowClearCriteriaButton: false,
        isShowResetButton: true,
        isShowColorLookup: false,
        isShowLookup: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error" + error);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  hideAlertPopupCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowPopupAlert: isDisplayed,
      error_list: [],
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  onPopUpChange = (e) => {
    let inventoryAllocationData = this.state.inventoryAllocationData;
    let allocationData = { ...inventoryAllocationData };
    allocationData[e.target.name] = e.target.value;
    inventoryAllocationData = allocationData;
    this.setState({ inventoryAllocationData: inventoryAllocationData });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowNewLinePopup: isShowPopup,
      moduleForPopup: [],
    });
  };
  clearCriteria = () => {
    let criteria = new ManualInventoryCustomerAllocationSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.fabricStyleName = "";
    criteria.status = "O";
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
    });
    this.hideAlertCallBack();
  };
  popupClearCriteria = (e) => {
    if (e.detail === 1) {
      let criteria = new ManualInventoryCustomerAllocationBean();
      criteria.companyCode = this.companyCode;
      criteria.status = "O";
      this.setState({
        inventoryAllocationData: criteria,
        isShowPopupColorLookup: false,
      });
      this.hideAlertPopupCallBack();
    }
  };
  reset = () => {
    let criteria = new ManualInventoryCustomerAllocationSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.fabricStyleName = "";
    criteria.status = "O";
    this.setState({
      criteria: criteria,
      isInventoryDatasFound: false,
      inventoryDataList: new Array(),
      isDisableFields: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowLookup: true,
      isShowColorLookup: false,
      //isViewMode: false,
    });
    this.hideAlertCallBack();
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: false,
        criteria: criteria,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
  };

  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    if (!isEmpty(fabricStyleCode)) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
      });
      this.readandsetFabricStyleDetail(fabricStyleCode);
      this.setState({ fabricPageListForAutoCompleteList: new Array() });
    }
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let fabricStyleColorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(fabricStyleColorCode)) {
      let criteria = this.state.criteria;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: false,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompleteFabricColorList === true &&
      fabricStyleColorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let criteria = this.state.criteria;
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (fabricStyleColorCode) => {
    let criteria = this.state.criteria;
    criteria.fabricStyleColorCode = fabricStyleColorCode;
    this.setState({ criteria: criteria });
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: false,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList == true &&
      customerCode !== ""
    ) {
      setTimeout(() => {
        this.readCustomerBySearchString(e.target.value);
      }, 200);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ critera: tempCriteria });
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let customer_pageList = new RestPageListBean();
    customer_pageList.pageSize = 10;
    let customer_requestInput = new RestCustomerListRequest();
    customer_requestInput.pageInput = customer_pageList;
    customer_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      customer_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  viewFabricModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  allocatedQuantity = (e, code, rowData) => {
    if (e.detail === 1) {
      let inventoryAllocationData = rowData;
      this.setState({
        isShowNewLinePopup: true,
        isShowPopupLookup: false,
        inventoryAllocationData: inventoryAllocationData,
        showClearButton: false,
        isShowDisableFields: true,
      });
    }
  };
  newManualInventoryAllocation = (e) => {
    if (e.detail === 1) {
      let criteria = this.state.criteria;
      if (isEmpty(criteria.status)) {
        let status = "O";
        criteria.status = status;
      }
      criteria.companyCode = this.companyCode;
      let inventoryAllocationData = new ManualInventoryCustomerAllocationBean();
      inventoryAllocationData.companyCode = this.companyCode;
      inventoryAllocationData.customerCode = criteria.customerCode;
      inventoryAllocationData.customerName = criteria.customerName;
      inventoryAllocationData.fabricStyleCode = criteria.fabricStyleCode;
      inventoryAllocationData.fabricStyleName = criteria.fabricStyleName;
      inventoryAllocationData.fabricStyleColorCode =
        criteria.fabricStyleColorCode;
      inventoryAllocationData.status = criteria.status;
      this.setState({
        isShowNewLinePopup: true,
        isShowPopupLookup: true,
        showClearButton: true,
        inventoryAllocationData: inventoryAllocationData,
        isShowDisableFields: false,
        isShowPopupColorLookup: false,
      });
    }
  };
  generateCustomerAllocation = (e) => {
    if (e.detail === 1) {
      let customerAllocation = this.state.inventoryAllocationData;
      customerAllocation.companyCode = this.companyCode;
      let isValidLine = false;
      isValidLine = this.validateCALine(customerAllocation);
      if (isValidLine) {
        if (!isEmpty(customerAllocation.code)) {
          if (
            SecurityAccessManager.CustomerAllocationMaintenanceEdit_IsAccessible()
          ) {
            InventoryService.updateManualInventoryCustomerAllocation(
              customerAllocation,
              this.generateCustomerAllocationPageResponse,
              this.errorCallBack
            );
          } else {
            this.inValidAccess(1);
          }
        } else {
          if (
            SecurityAccessManager.CustomerAllocationMaintenanceCreate_IsAccessible()
          ) {
            InventoryService.createManualInventoryCustomerAllocation(
              customerAllocation,
              this.generateCustomerAllocationPageResponse,
              this.errorCallBack
            );
          } else {
            this.inValidAccess(1);
          }
        }
      }
    }
  };
  generateCustomerAllocationPageResponse = (response) => {
    if (response.data != null && response.data.success == true) {
      this.showInfoMessage(response.data);
      setTimeout(() => {
        //this.fetch();
        this.hideAlertCallBack();
        this.loadPage(1);
      }, 500);
    } else {
      this.showErrorMessage(response.data);
    }
    let criteria = this.state.criteria;
    criteria.startDate = "";
    criteria.stopDate = "";
    this.setState({
      criteria: criteria,
      isShowNewLinePopup: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  validateCALine = (lineBean) => {
    let isValidCALine = false;
    let err_list = [];
    if (isEmpty(lineBean.customerCode)) {
      let errMsg = " CustomerCode is Required!";
      err_list.push(errMsg);
    }
    if (isEmpty(lineBean.customerName)) {
      let errMsg = " CustomerName is Required!";
      err_list.push(errMsg);
    }
    if (isEmpty(lineBean.customerPurchaseOrderNumber)) {
      let errMsg = "Customer P.O  is Required!";
      err_list.push(errMsg);
    }
    if (isEmpty(lineBean.fabricStyleCode)) {
      let errMsg = "";
      if (!this.state.is3PL) {
        errMsg = "FabricCode is Required";
      } else {
        errMsg = "ItemCode is Required";
      }
      err_list.push(errMsg);
    }
    if (isEmpty(lineBean.fabricStyleName)) {
      let errMsg = "";
      if (!this.state.is3PL) {
        errMsg = "FabricName is Required";
      } else {
        errMsg = "ItemName is Required";
      }
      err_list.push(errMsg);
    }
    if (isEmpty(lineBean.fabricStyleColorCode)) {
      let errMsg = "ColorCode is Required!";
      err_list.push(errMsg);
    }
    if (isEmpty(lineBean.startDate)) {
      let errMsg = "StartDate is Required!";
      err_list.push(errMsg);
    }
    if (isEmpty(lineBean.stopDate)) {
      let errMsg = "StopDate is Required!";
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      isValidCALine = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    } else {
      isValidCALine = true;
      this.setState({ isShowPopupAlert: false });
    }
    return isValidCALine;
  };
  fabricCodePopupOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompletePopupFabricList = true;
    let tempCriteria = this.state.inventoryAllocationData;
    let showAutoCompleteList = this.state.showAutoCompletePopupFabricList;
    if (isEmpty(fabricStyleCode)) {
      let inventoryAllocationData = this.state.inventoryAllocationData;
      inventoryAllocationData.fabricStyleCode = "";
      inventoryAllocationData.fabricStyleName = "";
      inventoryAllocationData.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePopupFabricList: false,
        inventoryAllocationData: inventoryAllocationData,
        isShowPopupColorLookup: false,
        colorList: [],
        fabricPageListForPopupAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readPopupFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ inventoryAllocationData: tempCriteria });
  };
  readandsetPopupFabricStyleDetailResponse = (response) => {
    let inventoryAllocationData = this.state.inventoryAllocationData;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        inventoryAllocationData.fabricStyleCode = fabricStyle.code;
        inventoryAllocationData.fabricStyleName = fabricStyle.description;
        inventoryAllocationData.widthCode = fabricStyle.width;
        inventoryAllocationData.uomCode = fabricStyle.inventoryUomCode;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowPopupColorLookup: true,
            inventoryAllocationData: inventoryAllocationData,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
            showAutoCompletePopupFabricList: false,
          });
        }
      }
    }
  };
  readandsetPopupFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetPopupFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readPopupFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByPopupFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByPopupFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForPopupAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyPopupEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    if (!isEmpty(fabricStyleCode)) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
      });
      this.readandsetPopupFabricStyleDetail(fabricStyleCode);
      this.setState({ fabricPageListForPopupAutoCompleteList: new Array() });
    }
  };
  displayPopupAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePopupFabricList: showAutoCompleteList });
  };
  onFabricColourPopupCodeChange = (e) => {
    this.state.showAutoCompletePopupFabricColorList = true;
    let fabricStyleColorCode = e.target.value;
    let showAutoCompletePopupFabricColorList =
      this.state.showAutoCompletePopupFabricColorList;
    if (isEmpty(fabricStyleColorCode)) {
      let inventoryAllocationData = this.state.inventoryAllocationData;
      inventoryAllocationData.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePopupFabricColorList: false,
        inventoryAllocationData: inventoryAllocationData,
        fabricColourPageListForPopupAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompletePopupFabricColorList === true &&
      fabricStyleColorCode !== ""
    ) {
      this.readPopupFabricColourBySearchString(e.target.value);
    }
  };
  readPopupFabricColourBySearchString(searchString) {
    let inventoryAllocationData = this.state.inventoryAllocationData;
    inventoryAllocationData.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForPopupAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourPopupEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStylePopupColorSelected(fabricStyleColourCode);
    this.setState({
      fabricColourPageListForPopupAutoCompleteList: new Array(),
    });
  };
  displayAutoCompletePopupFabricColorList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompletePopupFabricColorList: showAutoCompleteList,
    });
  };
  fabricStylePopupColorSelected = (fabricStyleColorCode) => {
    let inventoryAllocationData = this.state.inventoryAllocationData;
    inventoryAllocationData.fabricStyleColorCode = fabricStyleColorCode;
    this.setState({ inventoryAllocationData: inventoryAllocationData });
  };
  customerCodePopupOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompletePopupCustomerList = true;
    let tempCriteria = this.state.inventoryAllocationData;
    let showAutoCompleteList = this.state.showAutoCompletePopupCustomerList;
    if (isEmpty(customerCode)) {
      let inventoryAllocationData = this.state.inventoryAllocationData;
      inventoryAllocationData.customerCode = "";
      inventoryAllocationData.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePopupCustomerList: false,
        inventoryAllocationData: inventoryAllocationData,
        customerPageListForPopupAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList == true &&
      customerCode !== ""
    ) {
      setTimeout(() => {
        this.readPopupCustomerBySearchString(e.target.value);
      }, 200);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ inventoryAllocationData: tempCriteria });
  };
  readandsetPopupCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetPopupCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readandsetPopupCustomerDetailResponse = (response) => {
    let inventoryAllocationData = this.state.inventoryAllocationData;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        inventoryAllocationData.customerName = customerData.description;
        inventoryAllocationData.customerCode = customerData.code;
        this.setState({
          inventoryAllocationData: inventoryAllocationData,
        });
      }
    }
  };
  readPopupCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let customer_pageList = new RestPageListBean();
    customer_pageList.pageSize = 10;
    let customer_requestInput = new RestCustomerListRequest();
    customer_requestInput.pageInput = customer_pageList;
    customer_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      customer_requestInput,
      this.readByPopupCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByPopupCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForPopupAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodePopupEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetPopupCustomerDetail(customerCode);
    this.setState({
      customerPageListForPopupAutoCompleteList: new Array(),
    });
  };
  displayAutoPopupCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePopupCustomerList: showAutoCompleteList });
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.inventoryDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inventoryDataList: sorted });
    }
  };
  render() {
    let inventoryDataList = this.state.inventoryDataList;
    let inventoryAllocationData = this.state.inventoryAllocationData;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          hideAlertCallBack={this.hideAlertCallBack}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          clearCriteria={this.clearCriteria}
          onModuleExit={this.onModuleExit}
          reset={this.reset}
          extend_toolbar={
            <>
              {this.state.isShowFetchButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.newManualInventoryAllocation(e)}
                >
                  NEW
                </Button>
              )}
              {this.state.isShowFetchButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.fetch(e)}
                >
                  Fetch
                </Button>
              )}
            </>
          }
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
        />

        {this.state.isInventoryDatasFound && (
          <div className="div_default">
            <Table id="fabrics_tables">
              <thead>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "fabricStyleCode")
                  }
                >
                  {this.state.is3PL ? "Item#" : "FabricStyle#"}
                  {this.state.order === "code" &&
                  this.state.sortField === "fabricStyleCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "fabricStyleName")
                  }
                >
                  Name
                  {this.state.order === "code" &&
                  this.state.sortField === "fabricStyleName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "fabricStyleColorCode")
                  }
                >
                  Color
                  {this.state.order === "code" &&
                  this.state.sortField === "fabricStyleColorCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "widthCode")}>
                  Width
                  {this.state.order === "code" &&
                  this.state.sortField === "widthCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "skuNumber")}>
                  Sku
                  {this.state.order === "code" &&
                  this.state.sortField === "skuNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "startDate")}>
                  Start Date
                  {this.state.order === "code" &&
                  this.state.sortField === "startDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "stopDate")}>
                  Stop Date
                  {this.state.order === "code" &&
                  this.state.sortField === "stopDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "uomCode")}>
                  UOM
                  {this.state.order === "code" &&
                  this.state.sortField === "uomCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "allocatedQuantity")
                  }
                >
                  Allocated Qty
                  {this.state.order === "code" &&
                  this.state.sortField === "allocatedQuantity" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </thead>
              <tbody>
                {inventoryDataList.map((data, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewFabricModule(e, data.fabricStyleCode)
                        }
                      >
                        {data.fabricStyleCode}
                      </Button>
                    </td>
                    <td>{data.fabricStyleName}</td>
                    <td>{data.fabricStyleColorCode}</td>
                    <td>{data.widthCode}</td>
                    <td className="text-right">{data.skuNumber}</td>
                    <td>{data.startDate}</td>
                    <td>{data.stopDate}</td>
                    <td>{data.uomCode}</td>
                    <td className="text-right">
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.allocatedQuantity(
                            e,
                            data.allocatedQuantity,
                            data
                          )
                        }
                      >
                        {data.allocatedQuantity}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {inventoryDataList.length != 0 ? null : (
              <div className="no_Data">{"No Data"}</div>
            )}
          </div>
        )}

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricStyleModule}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowNewLinePopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Manual Inventory Allocation Details"}
          closeOnDocumentClick={false}
          popupLvlClass={"popupSizeLevel1"}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlert}
              hideAlertCallBack={this.hideAlertPopupCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="1"
                onClick={(e) => this.generateCustomerAllocation(e)}
              >
                Add/Update
              </Button>
              {this.state.showClearButton && (
                <Button
                  className="header_buttons enterFocus"
                  size="1"
                  onClick={(e) => this.popupClearCriteria(e)}
                >
                  clear
                </Button>
              )}
            </div>
          }
          content={
            <div className="sales_line_pop">
              {inventoryDataList != null && (
                <div>
                  <Row className="d-flex justify-content-left">
                    <Col sm="1">
                      <FormLabel>Customer</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        ref={this.customerCodePopupRef}
                        name="customerCode"
                        onChange={this.customerCodePopupOnChange}
                        lookupRequired={this.state.isShowPopupLookup}
                        value={inventoryAllocationData.customerCode}
                        lookupHandler={this.state.customerLookupHandler}
                        enterKeyEventHandler={
                          this.customerCodePopupEnterKeyEventHandler
                        }
                        autoCompleteListData={
                          this.state.customerPageListForPopupAutoCompleteList
                        }
                        displayAutoCompleteList={
                          this.displayAutoPopupCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        showAutoCompleteList={
                          this.state.showAutoCompletePopupCustomerList
                        }
                        disabled={this.state.isShowDisableFields}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="customerName"
                        onChange={this.onPopUpChange}
                        value={inventoryAllocationData.customerName}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      {this.state.is3PL ? (
                        <FormLabel>Item</FormLabel>
                      ) : (
                        <FormLabel>FabricSTyle</FormLabel>
                      )}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        ref={this.fabricCodePopupRef}
                        name="fabricStyleCode"
                        onChange={this.fabricCodePopupOnChange}
                        value={inventoryAllocationData.fabricStyleCode}
                        lookupRequired={this.state.isShowPopupLookup}
                        lookupHandler={this.state.fabricLookupHandler}
                        showCriteriaDialog={true}
                        enterKeyEventHandler={
                          this.fabricEnterKeyPopupEventHandler
                        }
                        autoCompleteListData={
                          this.state.fabricPageListForPopupAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoPopupCompleteList
                        }
                        showAutoCompleteList={
                          this.state.showAutoCompletePopupFabricList
                        }
                        disabled={this.state.isShowDisableFields}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="fabricStyleName"
                        onChange={this.onPopUpChange}
                        value={inventoryAllocationData.fabricStyleName}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Color</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        ref={this.colorCodePopupRef}
                        onChange={this.onFabricColourPopupCodeChange}
                        name="fabricStyleColorCode"
                        placeholder="color"
                        value={inventoryAllocationData.fabricStyleColorCode}
                        lookupRequired={this.state.isShowPopupColorLookup}
                        lookupHandler={this.state.colorLookupHandler}
                        enterKeyEventHandler={
                          this.fabricColourPopupEnterKeyEventHandler
                        }
                        autoCompleteListData={
                          this.state
                            .fabricColourPageListForPopupAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompletePopupFabricColorList
                        }
                        showAutoCompleteList={
                          this.state.showAutoCompletePopupFabricColorList
                        }
                        disabled={this.state.isShowDisableFields}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Width</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="widthCode"
                        value={inventoryAllocationData.widthCode}
                        onChange={this.onPopUpChange}
                        readOnly={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>StartDate</FormLabel>
                    </Col>
                    <Col sm="2">
                      <DatePickerComponent
                        name="startDate"
                        value={inventoryAllocationData.startDate}
                        onChange={this.onPopUpChange}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>StopDate</FormLabel>
                    </Col>
                    <Col sm="2">
                      <DatePickerComponent
                        name="stopDate"
                        value={inventoryAllocationData.stopDate}
                        onChange={this.onPopUpChange}
                        isMandatory={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Customer P.O#</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="customerPurchaseOrderNumber"
                        value={
                          inventoryAllocationData.customerPurchaseOrderNumber
                        }
                        onChange={this.onPopUpChange}
                        disabled={this.state.isShowDisableFields}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>UOM</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="uomCode"
                        value={inventoryAllocationData.uomCode}
                        onChange={this.onPopUpChange}
                        readOnly={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Allocated Oty</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="allocatedQuantity"
                        value={inventoryAllocationData.allocatedQuantity}
                        onChange={this.onPopUpChange}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel> Status</FormLabel>
                    </Col>
                    <Col sm="2">
                      <FormControl
                        as="select"
                        onChange={this.onPopUpChange}
                        name="status"
                        value={inventoryAllocationData.status}
                      >
                        <option value={"O"}>Open</option>
                        <option value={"F"}>Finished</option>
                        <option value={"X"}>Cancelled</option>
                      </FormControl>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Remarks</FormLabel>
                    </Col>
                    <Col sm="11">
                      <InputTextbox
                        name="remarks"
                        value={inventoryAllocationData.remarks}
                        onChange={this.onPopUpChange}
                      />
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          }
        ></MultiViewPopup>
      </div>
    );
  }
}

export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  const customerCodeOnChange = (e) => {
    props.customerCodeOnChange(e);
  };
  const fabricCodeOnChange = (e) => {
    props.fabricCodeOnChange(e);
  };
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  let customerLookupHandler = props.customerLookupHandler;
  let fabricLookupHandler = props.fabricLookupHandler;
  const customerCodeRef = props.customerCodeRef;
  let fabricCodeRef = React.createRef();
  let colorCodeRef = React.createRef();
  let criteria = props.criteria;

  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            onChange={customerCodeOnChange}
            lookupRequired={props.isShowLookup}
            value={criteria.customerCode}
            lookupHandler={customerLookupHandler}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            displayAutoCompleteList={displayAutoCompleteList}
            enableAutoCompleteTextBox={true}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="customerName"
            onChange={onChange}
            value={criteria.customerName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={props.isShowLookup}
            lookupHandler={fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="fabricStyleName"
            onChange={onChange}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          <FormLabel>Color</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={colorCodeRef}
            onChange={onFabricColourCodeChange}
            name="fabricStyleColorCode"
            placeholder="color"
            value={criteria.fabricStyleColorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Start Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="startDate"
            value={criteria.startDate}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Stop Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="stopDate"
            value={criteria.stopDate}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="1">
          <FormLabel> Status</FormLabel>
        </Col>
        <Col sm="2">
          <FormControl
            as="select"
            onChange={onChange}
            name="status"
            value={criteria.status}
            disabled={props.isDisableFields}
          >
            <option value={"O"}>Open</option>
            <option value={"F"}>Finished</option>
            <option value={"X"}>Cancelled</option>
          </FormControl>
        </Col>
      </Row>
    </div>
  );
}

function ManualInventoryAllocation(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App"></div>
      <ManualInventoryAllocationDetails {...props} name="" />
      <br />
    </div>
  );
}
export default ManualInventoryAllocation;
